import React, { LegacyRef, useRef } from 'react'
import ReactHlsPlayer from 'react-hls-player'

function TimelineMonitor({ src, type = 'stream' }: { src: string; type?: 'stream' | 'image' }) {
    const player: LegacyRef<HTMLVideoElement> = useRef()

    if (type === 'image') {
        return <img src={src} alt="Recording preview" style={{ display: 'block', width: '100%', height: '100%', objectFit: 'cover' }} />
    }

    return (
        <ReactHlsPlayer
            playerRef={player}
            src={src}
            autoPlay={true}
            muted={true}
            controls={false}
            crossOrigin="*"
            width={"100%"}
            height="auto"
        />
    )
}

export default TimelineMonitor
